import { actionGenerator } from '../../utils/redux/actionGenerator';
import { EPromoInfoActions } from '../../constants/actionTypes';
import { TCommonDealDetailKeys } from '../../types/promoInfo';

export const setCommonDealDetailsModalId = actionGenerator<
  EPromoInfoActions.setCommonDealDetailsModalId,
  TCommonDealDetailKeys | null
>(EPromoInfoActions.setCommonDealDetailsModalId);

export type TSetCommonDealDetailsModalIdAction = ReturnType<typeof setCommonDealDetailsModalId>;

export type TPromoInfoActions = TSetCommonDealDetailsModalIdAction;
